import { useDispatch } from 'react-redux';
import { useAutoFetch } from '@hooks';
import { saveSuccessServiceResponse, useNavigationStore, useSelectedSolution, useUserInput } from '@store';
import {
	TransactionTypeAliasAuthenticationTypeOperationInputDto,
	AliasAuthenticationTypeOperationOutputDto,
	Bank,
	TransactionType,
	TransactionsLabel,
} from '@api/izibizi-xp';

export const useFetchAuthenticatorType = () => {
	const dispatch = useDispatch();
	const { selectedAccount } = useUserInput();
	const { flow } = useNavigationStore();
	const selectedSolution = useSelectedSolution();
	let transactionType: TransactionType = TransactionType.IziBizi_Subscription;
	let transactionLabels: TransactionsLabel[] | null = null;
	if (flow === 'integratedSolution') {
		transactionType = TransactionType.IziBizi_IntegratedSolution_Subscription;
		transactionLabels = [
			{
				transactionLabelId: 2,
				transactionLabelVersionId: 0,
				labelValue: selectedSolution?.name,
			},
		];
	}

	return useAutoFetch<
		TransactionTypeAliasAuthenticationTypeOperationInputDto,
		AliasAuthenticationTypeOperationOutputDto
	>({
		data: {
			accountId: selectedAccount?.account.id,
			bank: Bank.MillenniumBcp,
			language: 'PT',
			transaction: transactionType,
			transactionAmount: 0,
			transactionCurrency: 'EUR',
			transactionLabels: transactionLabels,
		},
		cache: {
			key: 'aliasAuthenticationType',
			time: 0,
		},
		operationKey: 'aliasAuthenticationType',
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ aliasAuthenticationType: res.data }));
			}
		},
		withLoading: false,
	});
};
